// modules/reports/InKindOffersReport.jsx
import InKindBaseReport from "./InKindBaseReport";

const InKindOffersReport = () => {
  return (
    <InKindBaseReport
      title="In-Kind Crops"
      description="Match product donations with needs and track in-kind contributions"
      type="offers"
      categoryEndpoint="sub_category"
      categoryLabel="Product Category"
      resourceName="admin/in-kind-offers"
      statisticsEndpoint="admin/in-kind-offers/statistics"
    />
  );
};

export default InKindOffersReport;